import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import { EyeIcon } from '@heroicons/react/16/solid';
import '../styles/spinner/spinner.css';
import { getContactFormSubmissions } from '../redux/contactFormSubmissionSlice';
import ContactFormDetailModal from '../components/ContactFormDetailModal';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const ContactFormSubmissionsList = () => {
    const dispatch = useDispatch();
    const { contactFormSubmissions, status } = useSelector((state) => state.contactFormSubmissions);
    const { filterData } = useSearchExport();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedContactFormSubmission, setSelectedContactFormSubmission] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const contactFormSubmissionsPerPage = 50;

    useEffect(() => {
        dispatch(getContactFormSubmissions(null));  // Fetch all contactFormSubmissions on component load
    }, [dispatch]);

    const currentcontactFormSubmissions = filterData(contactFormSubmissions)
        .slice((currentPage - 1) * contactFormSubmissionsPerPage, currentPage * contactFormSubmissionsPerPage);

    const handleRowClick = (contactFormSubmission) => {
        setSelectedContactFormSubmission(contactFormSubmission);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedContactFormSubmission(null);
    };

    return (
        <div className="container mx-auto p-6">

            {/* Render the loader if the status is 'idle' */}
            {status === 'idle' && <RecordsLoader text="Loading All Contact Submissions, please hold on..." />}

            <h1 className="text-2xl text-black font-bold mb-6">Contact Form Submissions List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={contactFormSubmissions} fileName="contact-forms-submissions" />

            {status === 'failed' && <p>Error loading contact form submissions</p>}

            {/* Open Call List Table */}
            {status === 'succeeded' && (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">ID</th>
                                <th className="px-4 py-2">Sender Email</th>
                                <th className="px-4 py-2">Reciever Email</th>
                                <th className="px-4 py-2">Subject</th>
                                <th className="px-4 py-2">Body</th>
                                <th className="px-4 py-2">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentcontactFormSubmissions.length > 0 ? (
                                currentcontactFormSubmissions.map((contactFormSubmission) => (
                                    <tr
                                        key={contactFormSubmission.id}
                                        className="border-b cursor-pointer hover:bg-gray-100"
                                    >
                                        <td className="px-4 py-2">{contactFormSubmission.id}</td>
                                        <td className="px-4 py-2">{contactFormSubmission.sender_email}</td>
                                        <td className="px-4 py-2">{contactFormSubmission.reciever_email}</td>
                                        <td className="px-4 py-2">
                                            {contactFormSubmission.subject.split(' ').slice(0, 5).join(' ')}{contactFormSubmission.subject.split(' ').length > 5 ? '...' : ''}
                                        </td>
                                        <td className="px-4 py-2">
                                            {contactFormSubmission.body.split(' ').slice(0, 5).join(' ')}{contactFormSubmission.body.split(' ').length > 5 ? '...' : ''}
                                        </td>
                                        <td className="px-4 py-2 flex">
                                            <EyeIcon className="size-6 text-blue-500 ml-4" onClick={() => handleRowClick(contactFormSubmission)} />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4">No contactFormSubmissions Found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Open Call Detail Modal */}
                    <ContactFormDetailModal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        contactFormSubmission={selectedContactFormSubmission}
                    />

                    {/* Pagination */}
                    {contactFormSubmissions.length > contactFormSubmissionsPerPage && (
                        <Pagination
                            usersPerPage={contactFormSubmissionsPerPage}
                            totalUsers={contactFormSubmissions.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ContactFormSubmissionsList;